var app = angular.module('leonardo');

var PropertyAmenityService = function(BaseRestService, RestangularProvider, $q, ConfigThemeService, Upload) {
  var service = new BaseRestService('properties/amenities');

  var canceler_reports = $q.defer();

  service.getReports = function(params, noCancel) {
    if(!noCancel){
      canceler_reports.resolve();
      canceler_reports = $q.defer();
    }
    return RestangularProvider.all('properties/amenities').withHttpConfig({timeout: canceler_reports.promise}).customPOST(params, 'report');
  };

  service.importExcel = function(params) {
    return Upload.upload({
      url: ConfigThemeService.generateURL('/api/2.0/properties/amenities/import-excel/'),
      arrayKey: '',
      data: {
        account: params.account,
        file: params.file[0].file,
        response_email_recipients: params.response_email_recipients
      }
    });
  };

  service.exportExcel = function(params) {
    return RestangularProvider.all('properties/amenities').customGET('export-amenities', params);
  };

  return service;
};

app.factory('PropertyAmenityService', ['BaseRestService', 'Restangular', '$q', 'ConfigThemeService', 'UploadBase', PropertyAmenityService]);
